import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { Options } from 'highcharts';
import { IUsuario } from 'modelos/src';
import { IMongoDateToStringFormat } from 'modelosSeguridad/src';
import * as Highcharts from 'highcharts';
import { ReportesGenericosService } from '../../../../../auxiliares/servicios/http/reportes-genericos.service';
import { ChartColors } from '../../../../../auxiliares/servicios/chart-colors.service';

@Component({
  selector: 'app-chart-consumo-gpe',
  templateUrl: 'chart-consumo-gpe.component.html',
  styleUrls: ['./chart-consumo-gpe.component.scss'],
  standalone: false,
})
export class ChartConsumoGPEComponent implements OnInit {
  private reportesGenericosService = inject(ReportesGenericosService);

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  // datos de ejemplo, luego reemplazas por los que te manda tu servicio
  public datos: any[];
  // Outputs
  @Output() consumoUltimoMes = new EventEmitter<number>();
  // Publics
  public chart?: Options;
  public usuario?: IUsuario;
  public dateFormat: IMongoDateToStringFormat = '%Y-%m-%d';
  // Datos
  public consumo?: { fecha: string; cantidad: number }; //IResumenEventoSirenaPorFecha[];
  public eventosTotales?: number;
  public loading = false;

  private async listar() {
    const res = await this.reportesGenericosService.getResumenMensual();

    let ultimos = res.slice(-3);
    if (ultimos.length < 3) {
      const result = [...ultimos];

      let first = ultimos[0] || {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      };

      while (result.length < 3) {
        let prevMonth = first.month - 1;
        let prevYear = first.year;
        if (prevMonth === 0) {
          prevMonth = 12;
          prevYear -= 1;
        }
        result.unshift({ year: prevYear, month: prevMonth, consumoTotal: 0 });
        first = { year: prevYear, month: prevMonth, consumoTotal: 0 };
      }

      ultimos = result;
    }

    this.datos = ultimos;
    this.consumoUltimoMes.emit(this.ultimoMes());
  }

  public ultimoMes() {
    if (!this.datos || this.datos.length === 0) return undefined;

    // Ordenar por año/mes
    const ordenados = [...this.datos].sort((a, b) =>
      a.year === b.year ? a.month - b.month : a.year - b.year,
    );

    let ultimo = ordenados[ordenados.length - 1]; // último dato
    const hoy = new Date();
    const mesActual = hoy.getMonth() + 1; // 1..12
    const anioActual = hoy.getFullYear();

    // Verificar si el último dato corresponde al mes actual
    const esMesActual =
      ultimo.year === anioActual && ultimo.month === mesActual;

    // Si es mes actual y consumo=0, usamos el mes anterior si existe
    if (esMesActual && ultimo.consumoTotal === 0 && ordenados.length > 1) {
      ultimo = ordenados[ordenados.length - 2];
    }

    // Calcular cantidad de días para dividir
    let diasParaDividir: number;
    if (ultimo.year === anioActual && ultimo.month === mesActual) {
      // Mes actual: días transcurridos
      diasParaDividir = hoy.getDate();
    } else {
      // Mes anterior o histórico: total de días del mes
      diasParaDividir = new Date(ultimo.year, ultimo.month, 0).getDate();
    }

    // Devolver promedio diario
    return ultimo.consumoTotal / diasParaDividir;
  }

  private crearGrafico() {
    // Convertimos datos a [timestamp, consumo] para usar datetime en X
    const serieData = this.datos.map((d) => [
      new Date(d.year, d.month - 1).getTime(),
      d.consumoTotal,
    ]);

    this.chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: 'var(--bg-grafico)',
        style: {
          color: 'var(--fg-grafico)',
        },
        height: 300,
      },
      title: {
        text: 'Consumo Mensual',
        style: {
          color: 'var(--fg-grafico)',
          fontWeight: 'bold',
        },
      },
      xAxis: {
        categories: this.datos.map(
          (d) => `${d.month.toString().padStart(2, '0')}/${d.year}`,
        ),
        title: { text: 'Mes/Año', style: { color: 'var(--fg-grafico-alt)' } },
        labels: {
          style: {
            color: 'var(--fg-grafico)',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Consumo Total',
          style: { color: 'var(--fg-grafico-alt)' },
        },
        labels: {
          style: {
            color: 'var(--fg-grafico)',
          },
        },
      },
      legend: {
        // enabled: true,
        // layout: 'horizontal',
        // align: 'center',
        // verticalAlign: 'bottom',
        itemStyle: {
          color: 'var(--p-text-color)',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{point.key}</span><br>',
        pointFormat: '<b>{point.y}</b>',
      },
      plotOptions: {
        column: {
          dataLabels: { enabled: true },
        },
      },
      exporting: {
        enabled: false,
      },
      series: [
        {
          type: 'column', // obligatorio para tipado
          name: 'Consumo',
          data: this.datos.map((d) => d.consumoTotal),
          colorByPoint: true,
          color: ChartColors.color1(),
        } as Highcharts.SeriesColumnOptions,
      ],
    };
  }

  async ngOnInit() {
    this.loading = true;
    await this.listar();
    this.crearGrafico();

    this.loading = false;
  }
}
